"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WolfMotorDeclineText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var WolfMotorDeclineText = /** @class */ (function () {
    function WolfMotorDeclineText(props) {
        var _a, _b;
        this.props = props;
        var interaction = this.props.interaction;
        var underwritingResult = interaction.underwritingResult[0];
        this.index = ((_a = underwritingResult.objectReference) === null || _a === void 0 ? void 0 : _a.index) || 0;
        this.driver = this.getDriver(interaction, underwritingResult);
        var isPolicyHolder = ((_b = underwritingResult.objectReference) === null || _b === void 0 ? void 0 : _b.objectName) === "policyHolder";
        this.underwritingResultCustomerWordings = this.generateUnderwritingMessages(underwritingResult, isPolicyHolder);
    }
    ;
    WolfMotorDeclineText.prototype.getDriver = function (interaction, underwritingResult) {
        var _a, _b;
        if (((_a = underwritingResult.objectReference) === null || _a === void 0 ? void 0 : _a.objectName) === "additionalDrivers" &&
            ((_b = interaction.additionalDrivers) === null || _b === void 0 ? void 0 : _b.length) !== 0 &&
            interaction.additionalDrivers[this.index]) {
            return interaction.additionalDrivers[this.index];
        }
        return interaction.policyHolder;
    };
    WolfMotorDeclineText.prototype.generateUnderwritingMessages = function (underwritingResult, isPolicyHolder) {
        var defaultMessage = (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] });
        var personalizedMessage = (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "We can't insure ", this.driver.firstName, ".", (0, jsx_runtime_1.jsx)("br", {}), "If you'd like to continue with your quote without ", this.driver.firstName, " included, please remove them."] });
        var defaultCarMessage = (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure your car."] });
        var wrongVehicleTypeMessage = (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure this type of vehicle."] });
        var wrongLicenceTypeMessage = (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure your licence type."] });
        var ageRestrictionMessage = (0, jsx_runtime_1.jsxs)("p", { children: ["Unfortunately we\u2019re unable to offer you a quote due to the age limit on our policies.", (0, jsx_runtime_1.jsx)("br", {}), "To help you get the cover you need, you may like to", (0, jsx_runtime_1.jsx)("a", { className: "font-weight-bold", href: "https://www.biba.org.uk/find-insurance/", children: " find a provider using BIBA" }), " - the British Insurance Brokers\u2019 Association."] });
        var drivingHistoryMessage = (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because of your driving history."] });
        var detailsMismatchMessage = (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry we can't insure you...", (0, jsx_runtime_1.jsx)("br", {}), "\"Based on some of the information you\u2019ve provided, we\u2019re unable to give you a quote.", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), "We check the information you provide against a range of industry databases. If there\u2019s a mismatch in these details, we might not be able to provide you with a quote.\"", (0, jsx_runtime_1.jsx)("br", {}), "For example:", (0, jsx_runtime_1.jsx)("br", {}), "- Details of any previous claims made by drivers on the account. This includes the dates of any claims, whether the claim was fault or non-fault, regardless of whether the driver had a policy in their own name at the time.", (0, jsx_runtime_1.jsx)("br", {}), "- Use of the car. The registered keeper or main user and where the vehicle is kept may affect our ability to provide cover so it's important this is correctly recorded.", (0, jsx_runtime_1.jsx)("br", {}), "- The driving history for each driver. Driving history for each driver may affect our ability to provide cover."] });
        var trackerIsMissingMessage = (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't offer you a quote because we require a tracker to be fitted to the ", this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                    this.props.interaction.vehicles[this.index].make, ", ", this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                    this.props.interaction.vehicles[this.index].model, " (", this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                    this.props.interaction.vehicles[this.index].registrationNumber, ")."] });
        var declineReason = this.mapDeclineReason(underwritingResult.objectName, isPolicyHolder);
        var referralDeclineMessage = ((0, jsx_runtime_1.jsxs)("div", { className: "font-weight-light", children: [(0, jsx_runtime_1.jsxs)("div", { children: ["Unfortunately we\u2019re unable to offer you a quote", declineReason, "."] }), (0, jsx_runtime_1.jsxs)("div", { className: "mt-3", children: ["Please call our friends at Gallagher on ", (0, jsx_runtime_1.jsx)("b", { children: "0161 529 1459" }), " to see if they can help you find the cover you need or visit the British Insurance Brokers\u2019 Association\u00A0", (0, jsx_runtime_1.jsx)("a", { className: "font-weight-bold", href: "https://BIBA.org.uk/find-insurance", children: "BIBA.org.uk/find-insurance" }), " to look for suitable options."] })] }));
        return [
            {
                key: "UWW000",
                value: defaultMessage
            },
            {
                key: "UWW001",
                value: referralDeclineMessage
            },
            {
                key: "UWW002",
                value: ageRestrictionMessage
            },
            {
                key: "UWW003",
                value: defaultMessage
            },
            {
                key: "UWW004",
                value: referralDeclineMessage
            },
            {
                key: "UWW005",
                value: referralDeclineMessage
            },
            {
                key: "UWW006",
                value: isPolicyHolder ? wrongLicenceTypeMessage : personalizedMessage
            },
            {
                key: "UWW007",
                value: drivingHistoryMessage
            },
            {
                key: "UWW008",
                value: drivingHistoryMessage
            },
            {
                key: "UWW009",
                value: drivingHistoryMessage
            },
            {
                key: "UWW010",
                value: detailsMismatchMessage
            },
            {
                key: "UWW012",
                value: drivingHistoryMessage
            },
            {
                key: "UWW013",
                value: drivingHistoryMessage
            },
            {
                key: "UWW015",
                value: drivingHistoryMessage
            },
            {
                key: "UWW020",
                value: drivingHistoryMessage
            },
            {
                key: "UWW021",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you because you or any additional drivers have an unspent non-motoring conviction."] })
            },
            {
                key: "UWW022",
                value: defaultMessage
            },
            {
                key: "UWW023",
                value: referralDeclineMessage
            },
            {
                key: "UWW024",
                value: defaultCarMessage
            },
            {
                key: "UWW026",
                value: defaultMessage
            },
            {
                key: "UWW027",
                value: defaultMessage
            },
            {
                key: "UWW028",
                value: referralDeclineMessage
            },
            {
                key: "UWW029",
                value: referralDeclineMessage
            },
            {
                key: "UWW030",
                value: defaultMessage
            },
            {
                key: "UWW031",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we need ", this.driver.firstName, " to be assigned as a driver on your vehicle(s)."] })
            },
            {
                key: "UWW032",
                value: defaultMessage
            },
            {
                key: "UWW033",
                value: defaultMessage
            },
            {
                key: "UWW034",
                value: isPolicyHolder ? defaultMessage : personalizedMessage
            },
            {
                key: "UWW035",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure your car at this address."] })
            },
            {
                key: "UWW036",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we cant insure your car due to its age."] })
            },
            {
                key: "UWW037",
                value: wrongVehicleTypeMessage
            },
            {
                key: "UWW038",
                value: trackerIsMissingMessage
            },
            {
                key: "UWW041",
                value: referralDeclineMessage
            },
            {
                key: "UWW042",
                value: referralDeclineMessage
            },
            {
                key: "UWW043",
                value: defaultMessage
            },
            {
                key: "UWW044",
                value: defaultCarMessage
            },
            {
                key: "UWW045",
                value: defaultCarMessage
            },
            {
                key: "UWW046",
                value: defaultMessage
            },
            {
                key: "UWW047",
                value: defaultMessage
            },
            {
                key: "UWW048",
                value: defaultMessage
            },
            {
                key: "UWW049",
                value: referralDeclineMessage
            },
            {
                key: "UWW050",
                value: defaultMessage
            },
            {
                key: "UWW051",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...you can only replace your car up to four times per policy year."] })
            },
            {
                key: "UWW052",
                value: defaultMessage
            },
            {
                key: "UWW053",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you. This could be for a number of reasons, including your age or driving experience for the car you\u2019d like to insure."] })
            },
            {
                key: "UWW054",
                value: detailsMismatchMessage
            },
            {
                key: "UWW055",
                value: detailsMismatchMessage
            },
            {
                key: "UWW056",
                value: detailsMismatchMessage
            },
            {
                key: "UWW057",
                value: detailsMismatchMessage
            },
            {
                key: "UWW058",
                value: defaultMessage
            },
            {
                key: "UWW059",
                value: referralDeclineMessage
            },
            {
                key: "PVE03",
                value: defaultMessage
            }
        ];
    };
    WolfMotorDeclineText.prototype.mapDeclineReason = function (key, isPolicyHolder) {
        switch (key) {
            case "UWW001":
                return " due to your age";
            case "UWW005":
                return isPolicyHolder ? " due to your licence type" : " because we can't insure " + this.driver.firstName;
            case "UWW028":
                return " because the vehicle is used for commercial travelling, hire, or reward purposes.";
            case "UWW041":
                return " because one of the drivers lacks the required driving experience for this type of car.";
            case "UWW049":
                return isPolicyHolder ? "" : " because we can't insure " + this.driver.firstName;
            case "UWW059":
                return " due to the vehicle type.";
            default:
                return "";
        }
    };
    return WolfMotorDeclineText;
}());
exports.WolfMotorDeclineText = WolfMotorDeclineText;
//# sourceMappingURL=WolfMotorDeclineText.js.map